export default __webpack_public_path__ + "static/media/platform1.8a89fcd1.jpg";